import { useEffect } from "react"
import types from "prop-types"
import { store } from "store"
import { setFacilities } from "reduxSlices/facilitiesSlice"
import { setFacilitiesForFormSubmissions } from "reduxSlices/formSubmissionTableSlice"

const SetupFacilitiesInRedux = ({ facilities = [] }) => {
  useEffect(() => {
    store.dispatch(setFacilities(facilities))
    store.dispatch(setFacilitiesForFormSubmissions(facilities))
  }, [facilities])

  return null
}

SetupFacilitiesInRedux.propTypes = {
  facilities: types.arrayOf(types.object),
}

export default SetupFacilitiesInRedux
